import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2'
ChartJS.register(...registerables);
const BarChart = ({labels,avgData,myData,total}) => {
    return (
        <Bar data={{
            labels: labels,
            datasets: [
                {
                    label: '次數',
                    data: total,
                    borderWidth: 1,
                    backgroundColor: "#FFCC00",
                    order: 3,
                    barThickness:"20",
                },
                {
                    label: 'OOSA平均',
                    data: avgData,
                    borderWidth: 2,
                    borderColor: "#426FD9",
                    backgroundColor: "#426FD9",
                    type: "line",
                    pointRadius: 0,
                    order: 2,
                },
                {
                    label: '個人統計',
                    data: myData,
                    borderWidth: 2,
                    borderColor: "#0B1354",
                    backgroundColor: "#0B1354",
                    type: "line",
                    pointRadius: 0,
                    order: 1,
                }
            ]
        }}
            options={{
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 0 // 设置动画持续时间为0，即禁用动画
                },
                plugins: {
                    legend: {
                        position: 'bottom',  // 将标签位置设置在下方
                        labels: {
                            boxWidth: 21, // 色块的宽度（设置为原来的大约一半）
                            boxHeight: 7, // 色块的高度（可选，如果希望高度不同）
                            generateLabels: function (chart) {
                                const datasetMeta = chart.getDatasetMeta(0).controller.chart.data.datasets;
                                return [
                                    {
                                        text: '次數',
                                        fillStyle: datasetMeta[0].backgroundColor,
                                        strokeStyle: datasetMeta[0].borderColor,
                                        hidden: !chart.isDatasetVisible(0),
                                        datasetIndex: 0
                                    },
                                    {
                                        text: '個人統計',
                                        fillStyle: datasetMeta[2].backgroundColor,
                                        strokeStyle: datasetMeta[2].borderColor,
                                        hidden: !chart.isDatasetVisible(2),
                                        datasetIndex: 2
                                    },
                                    {
                                        text: 'OOSA平均',
                                        fillStyle: datasetMeta[1].backgroundColor,
                                        strokeStyle: datasetMeta[1].borderColor,
                                        hidden: !chart.isDatasetVisible(1),
                                        datasetIndex: 1
                                    }
                                ];
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: {
                            drawBorder: false,  // 隐藏X轴的边框线
                            drawTicks: false    // 隐藏X轴的刻度线
                        }
                    },
                    y: {
                        grid: {
                            drawBorder: false,  // 隐藏Y轴的边框线
                            drawTicks: false    // 隐藏Y轴的刻度线
                        }
                    }
                }
            }}
        />
    );
}

export default BarChart;